import React, {useEffect, useState} from 'react';
import { APIProvider, Map, useApiIsLoaded, useMap, Marker } from "@vis.gl/react-google-maps";
import Box from "@mui/material/Box";
import httpClient from '../../utils/httpClient';
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { API_KEY, MAPBOX_API_KEY } from "../../utils/config";
import Search from './Search';


const SearchBox = ({ boundingBox }) => {
  const apiIsLoaded = useApiIsLoaded();
  const map = useMap();
  const [polygon, setPolygon] = useState(null);
  
  useEffect(() => {
    
    if (!apiIsLoaded || !map) return;
   
    const boundingBoxCoords = [
      { lat: boundingBox.north, lng: boundingBox.west }, // Top-left
      { lat: boundingBox.north, lng: boundingBox.east }, // Top-right
      { lat: boundingBox.south, lng: boundingBox.east }, // Bottom-right
      { lat: boundingBox.south, lng: boundingBox.west }, // Bottom-left
      { lat: boundingBox.north, lng: boundingBox.west }  // Close the loop
    ];

    // Create a polygon
    const box = new window.google.maps.Polygon({
      paths: boundingBoxCoords,
      strokeColor: "#FF0000",
      strokeOpacity: 0.6,
      strokeWeight: 2,
      fillColor: "#FF6600",
      fillOpacity: 0.15,
      clickable: false
    });

    // Add the polygon to the map
    if(polygon) {
      polygon.setMap(null);
    }
    box.setMap(map);
    setPolygon(box);
  }, [boundingBox, apiIsLoaded, map]);

};

const GeolocationListener = ({setGeolocation, setAddress}) => {
  const map = useMap();
  useEffect(() => {

    if(!map) return;

    const listener = map.addListener('dblclick', async (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setGeolocation({ lat, lng });

      const result = await httpClient(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_API_KEY}`);
      const features = result.data.features;
      if (features.length) {
        const address = features[0].place_name;
        setAddress(address);
      }
    });

    return () => {
      listener.remove();
    }
  }, [map])
}

const Geolocation = ({location, setGeolocation, hideGeolocation, setAddress}) => {
  const [boundingBox, setBoundingBox] = useState([]);
  
  useEffect(() => {
   
    setTimeout(() => {
      document.getElementById('search2')?.focus(); // Ensures the input is ready
    }, 500);
  }, []);

  return (
    <>
      <APIProvider apiKey={API_KEY}>
        
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: 2,
          bgcolor: "rgb(244, 247, 250)",
          boxShadow: "0 8px 16px 0 #BDC9D7",
        }}
      >
        <Box
          alignItems="baseline"
          p={2}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit",
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ flexGrow: 1, mr: 1 }}>
            <Typography variant="h6">
              <b>Search for an address and/or click a point on the map</b>
            </Typography>
          </Box>
          <Box>
            <Link href="#" onClick={(e) => {
              e.preventDefault();
              hideGeolocation();
            }}>Close map</Link>
          </Box>
        </Box>
        
        <Box sx={{ display: "flex", flexWrap: "nowrap", gap: 2, p: 2, height: "800px", flexDirection: "column" }}>

          <Search searchID="search2" onPlaceSelected={setBoundingBox} />
          <Box sx={{ flexGrow: 1, minHeight: 0}}>
            <Map
              mapContainerStyle={{ height: "88%", width: "100%" }}
              defaultCenter={{ lat: 51.5074, lng: -0.1278 }}
              defaultZoom={8}
              mapId="AA_MAP_ID2"
              gestureHandling={"greedy"}
              disableDefaultUI={true}
            >
              <SearchBox boundingBox={boundingBox} />
              {location && <Marker position={location} />}
              <GeolocationListener setGeolocation={setGeolocation} setAddress={setAddress} />
            </Map>
          </Box>

        </Box>

      </Box>
    
      </APIProvider>
    </>
  );
};

export default Geolocation;